import React from 'react'

const PinCodeViewUI = ({context, messageList}) =>
  <div>
    ****
  </div>

export default PinCodeViewUI
